import { EntityDoc4det } from "../../entity/EntityDoc4det";

export class DtoDoc4detsPutRes extends EntityDoc4det {}
